import changeStatusFailure from './changeStatus/failure';
import changeStatusRequest from './changeStatus/request';
import changeStatusSuccess from './changeStatus/success';
import checkImportSpreadsheetRequest from './checkImportSpreadsheet/request';
import checkImportSpreadsheetSuccess from './checkImportSpreadsheet/success';
import createFailure from './create/failure';
import createRequest from './create/request';
import createSuccess from './create/success';
import editFailure from './edit/failure';
import editRequest from './edit/request';
import editSuccess from './edit/success';
import getAllFailure from './getAll/failure';
import getAllRequest from './getAll/request';
import getAllSuccessWithData from './getAll/successWithData';
import getAllSuccessWithoutData from './getAll/successWithoutData';
import importSpreadsheetFailure from './importSpreadsheet/failure';
import importSpreadsheetRequest from './importSpreadsheet/request';
import importSpreadsheetSuccess from './importSpreadsheet/success';
import removeFailure from './remove/failure';
import removeRequest from './remove/request';
import removeSuccess from './remove/success';
import setToggleImportSpreadsheetRemittanceInBackground from './set/importSpreadsheetInBackground';

const reducers = {
  changeStatusFailure,
  changeStatusRequest,
  changeStatusSuccess,
  checkImportSpreadsheetRequest,
  checkImportSpreadsheetSuccess,
  createFailure,
  createRequest,
  createSuccess,
  editFailure,
  editRequest,
  editSuccess,
  getAllFailure,
  getAllRequest,
  getAllSuccessWithData,
  getAllSuccessWithoutData,
  importSpreadsheetFailure,
  importSpreadsheetRequest,
  importSpreadsheetSuccess,
  removeFailure,
  removeRequest,
  removeSuccess,
  setToggleImportSpreadsheetRemittanceInBackground,
};

export default reducers;
